module.exports = __webpack_public_path__ + "static/media/Locationintelligence.5f4d0fa7.svg";